import { z } from 'zod';
import { strictRemoteCodec } from "./remote-codec.js";
const id = z.string().min(1).max(512);
const revision = z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER);
export const DualModelConfigSchema = z.object({
    enabled: z.boolean(), plannerModel: z.string().max(512), executorModel: z.string().max(512),
}).strict();
export const DualModelViewSchema = z.object({
    supported: z.boolean(), diagnostic: z.string().min(1).max(128).optional(),
    writable: z.boolean(), revision: revision.nullable(), configuration: DualModelConfigSchema,
    models: z.array(z.object({ id, name: z.string().min(1).max(1024) }).strict()).max(512),
    workspaces: z.array(z.object({ id, name: z.string().min(1).max(1024) }).strict()).max(1024),
}).strict();
export const DualModelSaveSchema = z.object({
    configuration: DualModelConfigSchema, expectedRevision: revision,
}).strict();
export const DualModelCreateSchema = z.object({
    requestId: z.string().uuid(), workspaceId: id, expectedRevision: revision,
}).strict();
export const DualModelCreateResultSchema = z.object({ sessionId: id }).strict();
const contribution = {
    package: 'dsh-github-copilot',
    descriptors: [
        {
            id: 'dsh-github-copilot:githubCopilotDualModel.view',
            namespace: 'githubCopilotDualModel', service: 'githubCopilotDualModel', method: 'view',
            invocation: { kind: 'direct' }, parameters: [],
            result: strictRemoteCodec('dsh-github-copilot#DualModelView', DualModelViewSchema),
        },
        {
            id: 'dsh-github-copilot:githubCopilotDualModel.save',
            namespace: 'githubCopilotDualModel', service: 'githubCopilotDualModel', method: 'save',
            invocation: { kind: 'direct' }, parameters: [{ name: 'input', wire: 'input', source: 'json',
                    codec: strictRemoteCodec('dsh-github-copilot#DualModelSaveRequest', DualModelSaveSchema) }],
            result: strictRemoteCodec('dsh-github-copilot#DualModelView', DualModelViewSchema),
        },
        {
            id: 'dsh-github-copilot:githubCopilotDualModel.create',
            namespace: 'githubCopilotDualModel', service: 'githubCopilotDualModel', method: 'create',
            invocation: { kind: 'direct' }, parameters: [{ name: 'input', wire: 'input', source: 'json',
                    codec: strictRemoteCodec('dsh-github-copilot#DualModelCreateRequest', DualModelCreateSchema) }],
            result: strictRemoteCodec('dsh-github-copilot#DualModelCreateResult', DualModelCreateResultSchema),
        },
    ],
};
export default contribution;
//# sourceMappingURL=dual-model-remote.js.map